module.exports = __webpack_public_path__ + "static/media/origami4.f865af44.jpg";